import React, { useContext } from "react";
import { HotelContext } from "../../../context/HotelContext";
import { translate } from "../../../utils/Translation";
import "./GraphCard.css";

const GraphCard = ({
  title,
  subtitle,
  children,
  legendTitle,
  legendSubtitle,
  legendDotColor = "#697F6A",
  legendContent = null,
  showYearSelector = false,
  year,
  onPreviousYear,
  onNextYear,
  className = "",
  contentClassName = "",
}) => {
  const { lang } = useContext(HotelContext);
  const cardClassName = ["graph-card", className].filter(Boolean).join(" ");
  const graphContentClassName = ["graph-card__content", contentClassName].filter(Boolean).join(" ");

  return (
    <div className={cardClassName}>
      <div className="graph-card__header">
        <h3 className="graph-card__title">{title}</h3>
        {subtitle ? <p className="graph-card__subtitle">{subtitle}</p> : null}
      </div>

      <div className={graphContentClassName}>{children}</div>

      {legendContent ? (
        <div className="graph-card__legend graph-card__legend--custom">{legendContent}</div>
      ) : (legendTitle || legendSubtitle) ? (
        <div className="graph-card__legend">
          <span className="graph-card__legend-dot" style={{ backgroundColor: legendDotColor }} />
          <div className="graph-card__legend-texts">
            {legendTitle ? <span className="graph-card__legend-title">{legendTitle}</span> : null}
            {legendSubtitle ? <span className="graph-card__legend-subtitle">{legendSubtitle}</span> : null}
          </div>
        </div>
      ) : null}

      {showYearSelector && (
        <div className="graph-card__year-selector">
          <button
            type="button"
            className="graph-card__year-arrow"
            onClick={onPreviousYear}
            aria-label={translate("v2_graph_prev_year", lang)}
          >
            ◀
          </button>
          <span className="graph-card__year-text">{translate("v2_graph_year_label", lang, { year })}</span>
          <button
            type="button"
            className="graph-card__year-arrow"
            onClick={onNextYear}
            aria-label={translate("v2_graph_next_year", lang)}
          >
            ▶
          </button>
        </div>
      )}
    </div>
  );
};

export default GraphCard;
